import { css } from "styled-components";

export const typography = {
    fontFamilyImportUrl: "/staticContent/fonts/stylesheet-segoe-ui.css",
    body: {
        fontFamily: "'SegoeUI', Arial, sans-serif",
        size: "14px",
        weight: 300,
        css: css`
            line-height: 24px;
        `,
    },
    p: {
        size: "14px",
        weight: 300,
        css: css`
            line-height: 24px;
        `,
    },
    h1: {
        size: "32px",
        weight: 600,
        css: css`
            line-height: 42px;
            position: relative;
            margin-bottom: 24px;
            
            &:after{
                content: "";
                display: block;
                position: absolute;
                background-color: ${({ theme }) => theme.colors.primary.main};
                width: 58px;
                height: 4px;
            }
        `,
    },
    h2: {
        size: "24px",
        weight: 600,
        css: css`
            line-height: 25px;
            position: relative;
            padding-left: 10px;
            margin-bottom: 22px;
            
            &:after{
                content: "";
                display: block;
                position: absolute;
                background-color: ${({ theme }) => theme.colors.primary.main};
                width: 3px;
                height: 25px;
                top: 0;
                left: 0;
            }
        `,
    },
    h3: {
        size: "18px",
        weight: 600,
        css: css`
            line-height: 26px;
            background-color: ${({ theme }) => theme.colors.secondary.main};
            display: inline-block;
            border-radius: 6px;
            padding: 4px 20px 6px;
            margin-bottom: 20px;
        `,
    },
    h4: {
        size: "16px",
        weight: 600,
        css: css`
            line-height: 22px;
            margin-bottom: 18px;
        `,
    },
    h5: {
        size: "16px",
        weight: 600,
        css: css`
            line-height: 22px;
            margin-bottom: 16px;
        `,
    },
    h6: {
        size: "14px",
        weight: 600,
        css: css`
            line-height: 18px;
            margin-bottom: 14px;
        `,
    },
    headerPrimary: {
        fontFamily: "'SegoeUI', Arial, sans-serif",
        size: "16px",
    },
    headerSecondary: {
        fontFamily: "'SegoeUI', Arial, sans-serif",
        size: "16px",
    },
    headerTertiary: {
        fontFamily: "'SegoeUI', Arial, sans-serif",
        size: "14px",
    },
    legend: {
        size: "14px",
    },
};